/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TransferRXDialog.vue?vue&type=template&id=47440d3a&scoped=true"
import script from "./TransferRXDialog.vue?vue&type=script&lang=js"
export * from "./TransferRXDialog.vue?vue&type=script&lang=js"
import style0 from "./TransferRXDialog.vue?vue&type=style&index=0&id=47440d3a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47440d3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47440d3a')) {
      api.createRecord('47440d3a', component.options)
    } else {
      api.reload('47440d3a', component.options)
    }
    module.hot.accept("./TransferRXDialog.vue?vue&type=template&id=47440d3a&scoped=true", function () {
      api.rerender('47440d3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/TransferRXDialog.vue"
export default component.exports